import { Box, Group, Pill, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { CenterReport } from '@/module/ResearchCenter/model/ResearchCenterTypes';

interface CenterReportBoxProps {
  report: CenterReport;
}

export function CenterReportBox({ report }: CenterReportBoxProps) {
  const { title, open } = report;
  const { t } = useTranslation();
  return (
    <Box mb="md">
      <Group>
        <Text fw="500">{title}</Text>
        <Pill bg={open ? 'green' : 'red'}>
          {open ? t('researchCenters.report.open') : t('researchCenters.report.closed')}
        </Pill>
      </Group>
    </Box>
  );
}
